import { DivisionStewardshipParams, StateProvinceByStateParams } from '../../models/APIModels';
import { ENV } from '../../envUtils';

/**
 * Endpoint path builders for AIM API resources including opportunities, transaction teams, divisions, employees, stewards, currencies, and reference data.
 *
 * Most properties are functions that combine ENV with a resource path; a few are plain strings (like `transactionRejectionReasons` and `transactionFailReasons`) which are intentionally empty placeholders.
 */
export const endpoints = {
  opportunities: `${ENV}/opportunities`,
  opportunityDetails: (aimOpportunity: number) => `${ENV}/opportunity/${aimOpportunity}`,
  opportunityAttachments: (aimOpportunity: number) => `${ENV}/opportunity/${aimOpportunity}/attachments`,
  transactionTeams: `${ENV}/transactionteams`,
  divisions: `${ENV}/divisions`,
  assetTypes: `${ENV}/assettypes`,
  managementTypes: `${ENV}/managementtypes`,
  employees: `${ENV}/employees`,
  divisionStewards: (aimDivision: string) => `${ENV}/division/${aimDivision}/stewards`,
  divisionStewardShip: (params: DivisionStewardshipParams) =>
    `${ENV}/division/${params.aimDivision}/steward/${params.aimStewardship}`,
  divisionEmployees: (aimDivision: string) => `${ENV}/division/${aimDivision}/employees`,
  documentSecurityLevels: `${ENV}/documentsecuritylevels`,
  documentSecurityLevel: (aimDocumentSecurityLevel: string) =>
    `${ENV}/documentsecuritylevel/${aimDocumentSecurityLevel}`,
  saleTypes: `${ENV}/saletypes`,
  countries: `${ENV}/countries`,
  reasonCodes: `${ENV}/reasoncodes`,
  transactionRoles: `${ENV}/transactionroles`,
  transactionTypes: `${ENV}/transactiontypes`,
  checklistMilestones: `${ENV}/checklistmilestones`,
  currencies: `${ENV}/currencies`,
  currency: (currency: string) => `${ENV}/currency/${currency}`,
  stewardships: `${ENV}/stewardships`,
  stewardship: (aimStewardship: string) => `${ENV}/stewardship/${aimStewardship}`,
  stewardshipsDivision: (aimDivision: string) => `${ENV}/stewardships/division/${aimDivision}`,
  stewardShipByStewardDivision: (params: DivisionStewardshipParams) =>
    `${ENV}/stewardship/${params.aimStewardship}/division/${params.aimDivision}`,
  employeesByDivision: (aimDivision: string) => `${ENV}/employees/division/${aimDivision}`,
  employee: (aimEmployee: string) => `${ENV}/employee/${aimEmployee}`,
  saleType: (aimSaleType: string) => `${ENV}/saletype/${aimSaleType}`,
  country: (country: string) => `${ENV}/country/${country}`,
  stateProvinces: `${ENV}/stateprovinces`,
  stateProvincesByCountry: (country: string) => `${ENV}/stateprovinces/${country}`,
  stateProvincesByState: (params: StateProvinceByStateParams) =>
    `${ENV}/stateprovince/${params.country}/${params.state}`,
  transactionRejectionReasons: '',
  transactionFailReasons: ''
};
